const imp = () => import(/* webpackChunkName: "ui_commont_icon"*/  "../sprite/loadSprite_edit_detail_form");
const loadMap_edit_detail_form: { [key: string]: () => Promise<any> } = {
  "Icon-Insert-forward": imp,
  "Icon-Move-to-group": imp,
  "Icon-Batch-editing": imp,
  "Icon-Insert-after-line": imp,
  "Icon-Move-down": imp,
  "Icon-Move-up": imp,
  "Icon-sort": imp,
}

export default loadMap_edit_detail_form;